module.exports = __webpack_public_path__ + "img/20170319-6.f12c8214.jpeg";